/*eslint-disable*/
import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { baseUri } from "../../utils/uri";


class AdminNavbar extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      Logo: ""
    }
  }
  componentDidMount () {
    axios.get(`${baseUri}/service-person/v1/properties/log`).then((res) => this.setState({Logo: res.data}))
  }
  render() {
    const {Logo} = this.state
    return (
      <>
        <Navbar
          className="navbar-top navbar-horizontal navbar-dark"
          expand="md"
        >
          <Container className="px-4">
            <NavbarBrand to="/admin/index" tag={Link} marginRight="3px">
              <img
                alt="logo"
                // eslint-disable-next-line global-require
                src={Logo}
              />
            </NavbarBrand>
            <button
              type="button"
              className="navbar-toggler"
              id="navbar-collapse-main"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
              <div className="navbar-collapse-header d-md-none">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    <Link to="/">
                      <img
                        alt="..."
                        // eslint-disable-next-line global-require
                        src={Logo}
                      />
                    </Link>
                  </Col>
                  <Col className="collapse-close" xs="6">
                    <button
                      type="button"
                      className="navbar-toggler"
                      id="navbar-collapse-main"
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
            </UncontrolledCollapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
